import { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BrandingCtx = createContext({ branding: null, refresh: () => {} });

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function BrandingProvider({ children }) {
  const [branding, setBranding] = useState(null);

  const load = () => {
    axios.get(`${API}/public/branding`).then((r) => setBranding(r.data)).catch(() => {});
  };

  useEffect(() => { load(); }, []);

  useEffect(() => {
    if (!branding) return;
    const t = branding.theme || {};
    const font = branding.font_main || "IBM Plex Sans";
    let style = document.getElementById("dishenda-branding");
    if (!style) {
      style = document.createElement("style");
      style.id = "dishenda-branding";
      document.head.appendChild(style);
    }
    style.textContent = `
      :root { --brand-primary: ${t.primary}; --brand-secondary: ${t.secondary}; --brand-accent: ${t.accent}; }
      .restaurant-area { background-color: ${t.background}; }
      .restaurant-area .bg-zinc-900 { background-color: ${t.primary} !important; color: #06283A !important; }
      .restaurant-area .border-zinc-900 { border-color: ${t.primary} !important; }
      .restaurant-area .text-zinc-900 { color: ${t.text} !important; }
      .restaurant-area button.bg-zinc-900:hover { background-color: ${t.primary} !important; filter: brightness(0.92); }
      body { font-family: '${font}', sans-serif; }
    `;
    const fontLinkId = "dishenda-brand-font";
    let link = document.getElementById(fontLinkId);
    if (!link) {
      link = document.createElement("link");
      link.id = fontLinkId;
      link.rel = "stylesheet";
      document.head.appendChild(link);
    }
    link.href = `https://fonts.googleapis.com/css2?family=${encodeURIComponent(font)}:wght@400;500;600;700;800&display=swap`;
    if (branding.logos?.favicon) {
      let fav = document.querySelector("link[rel='icon']");
      if (!fav) {
        fav = document.createElement("link");
        fav.rel = "icon";
        document.head.appendChild(fav);
      }
      fav.href = `${process.env.REACT_APP_BACKEND_URL}${branding.logos.favicon}`;
    }
  }, [branding]);

  return <BrandingCtx.Provider value={{ branding, refresh: load }}>{children}</BrandingCtx.Provider>;
}

export const useBranding = () => useContext(BrandingCtx);

export function BrandLogo({ slot = "main", fallbackClass = "font-display font-extrabold tracking-tight", className = "" }) {
  const { branding } = useBranding();
  const url = branding?.logos?.[slot] || branding?.logos?.main;
  if (!url) return <span className={`${fallbackClass} ${className}`}>DISHENDA</span>;
  return <img src={`${process.env.REACT_APP_BACKEND_URL}${url}`} alt="Dishenda" className={className || "h-8 w-auto object-contain"} data-testid={`brand-logo-${slot}`} />;
}
